import { render, staticRenderFns } from "./ShowObject.vue?vue&type=template&id=cc614f50&scoped=true"
import script from "./ShowObject.vue?vue&type=script&lang=js"
export * from "./ShowObject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc614f50",
  null
  
)

export default component.exports